<template>
    <div class="py-0">
        <div class="row">
            <div class="col-md-12 mb-4">
                <div>
                    <el-collapse>
                        <el-collapse-item>
                            <template slot="title">
                                <span class="ps-2" style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
                            </template>
                            <div class="px-2">
                                <el-form label-position="top" label-width="100px">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <el-form-item label="Station">
                                                <el-select v-model="stationid" clearable filterable placeholder="Select Station" size="small" style="width:100%;">
                                                    <el-option v-for="(item3, index0) in spbu.list" :key="item3.BOSStationId + '_' + index0" :label="item3.StationName" :value="item3.BOSStationId">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>

                                        <div class="col-md-6" >
                                            <el-form-item label="Area">
                                                <el-radio-group v-model="area" size="small" name="area">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>

                                        <div class="col-md-6" >
                                            <el-form-item label="Region">
                                                <el-radio-group v-model="region" size="small" name="region">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.region" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>

                                        <div class="col-md-6">
                                            <el-form-item label="Owner">
                                                <el-radio-group v-model="owner" size="small" name="owner">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.owner" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>

                                        <div class="col-md-3" v-if="tabName == 'ifca-billing' || tabName=='ifca-invoice' || tabName=='ifca-invoice-detail' ">
                                            <el-form-item label="Tahun">
                                                <el-select v-model="year" clearable filterable placeholder="Select Year" size="small">
                                                    <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>

                                        <div class="col-md-3" v-if="tabName == 'ifca-billing' || tabName=='ifca-invoice' || tabName=='ifca-invoice-detail' ">
                                            <el-form-item label="Bulan">
                                                <el-select v-model="month" clearable filterable placeholder="Select Month" size="small">
                                                    <el-option v-for="item3 in options.months" :key="item3.value" :label="item3.name" :value="item3.value">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </div>

                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-md-6">
                                            <el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
                                        </div>
                                    </div>
                                </el-form>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>

                <div class="row" v-if="false">
                    <div class="col-md-3 mb-2 mt-2">
                        <el-checkbox v-model="showchart">Show Chart</el-checkbox>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 mb-2">
                        <BarChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="380" v-if="showchart && charttype=='barchart'" :totalValue="this.totalValue"/>
                        <LineChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="192" v-if="showchart && charttype=='linechart'" style="margin-top:20px;"/>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 bg-white px-4">
                        <ReportResultTable :reportname="'NFRReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess"/>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Fuel from '@/components/page/Fuel.js'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import {Rainbow, Config, AppColors, Penanggalan, AxiosWithJar } from '@/utility.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'

export default
{
	extends:Fuel,
	components: {
        ReportResultTable,
        LineChart,
        BarChart,
    },
    props: ['tabIndex','tabName', 'tabLabel'],
    data(){
		return {
			reportdata: [],
            chartdata: [],
            showchart : false,
            stacked: true,
            charttype: 'barchart',
            totalValue: 0,

            urlRequestParams: '',
            //plant: '',
            stationid: '',
            stationtype: '',
            area: '',
            region: '',
            owner: '',
            lokasi: '',
            category: '',
            subcategory: '',
            status: '',
            group: 'detail',
            year: Penanggalan().tahun,
            month: Penanggalan().bulan,

            options: {
                area:[
					{ value: "", name: "ALL" },
					{ value: "1", name: "1" },
					{ value: "2", name: "2" },
					{ value: "3", name: "3" },
					{ value: "4", name: "4" },
					{ value: "5", name: "5" },
				],
                region:[
					{ value: "", name: "ALL" },
					//{ value: "region", name: "BY REGION", field: "RegionPertareId" },
					{ value: "1", name: "1" },
					{ value: "2", name: "2" },
					{ value: "3", name: "3" },
					{ value: "4", name: "4" },
					{ value: "5", name: "5" },
					{ value: "6", name: "6" },
					{ value: "7", name: "7" },
				],
				owner:[
					{ value: "", name: "ALL" },
					//{ value: "by_owner", name: "BY OWNER" },
					{ value: "COCO", name: "COCO" },
					{ value: "KSO", name: "KSO" },
					{ value: "TAC", name: "TAC" },
				],
                category:[
					{ value: "", name: "ALL" },
					{ value: "Driveway", name: "Driveway" },
					{ value: "Ruangan", name: "Ruangan" },
					{ value: "Lahan", name: "Lahan" },
				],
                subcategory:[
					{ value: "", name: "ALL" },
					{ value: "Kosong", name: "Kosong" },
					{ value: "Terisi", name: "Terisi" },
				],
                status:[
					{ value: "", name: "ALL" },
					{ value: "PTPR", name: "PTPR" },
					{ value: "Eksternal", name: "Eksternal" },
					{ value: "Ruang Kosong", name: "Ruang Kosong" },
				],
                group :[
					{ value: "", name: "ALL" },
					{ value: "spbu", name: "SPBU" },
					{ value: "detail", name: "Detail" },
				],
                months:[
                    //{value:'', name: 'Ytd'},
                    {value:1, name: 'Januari'},
                    {value:2, name: 'Februari'},
                    {value:3, name: 'Maret'},
                    {value:4, name: 'April'},
                    {value:5, name: 'Mei'},
                    {value:6, name: 'Juni'},
                    {value:7, name: 'Juli'},
                    {value:8, name: 'Agustus'},
                    {value:9, name: 'September'},
                    {value:10, name: 'Oktober'},
                    {value:11, name: 'November'},
                    {value:12, name: 'Desember'},
                ],
                years:[
                    {value:'2021', name: '2021'},
                    {value:'2022', name: '2022'},
                    {value:'2023', name: '2023'},
                    {value:'2024', name: '2024'},
                    {value:'2025', name: '2025'},
                ],
            },

            loading: {
                table: false,
                isSuccess: false,
            },
        }
    },
    computed:{

	},
    watch:{

    },
    mounted(){
        this.$emit('childrenRoute');
        this.loadStationList('SPBG');
        //this.getData()
    },
    methods: {
        async getData() {
			this.urlRequestParams = Config().apiURL
            if(this.tabName == 'spbg-sales')
                this.urlRequestParams += '/v1/spbg/sales?'
            else if(this.tabName == 'ifca-contract-alert')
                this.urlRequestParams += '/v1/nfr/ifcacontractalert?'
            else if(this.tabName == 'ifca-total-contract')
                this.urlRequestParams += '/v1/nfr/ifcatotalcontract?'
            else if(this.tabName == 'ifca-billing')
                this.urlRequestParams += '/v1/nfr/ifcabilling?'
            else if(this.tabName == 'ifca-total-contract-price')
                this.urlRequestParams += '/v1/nfr/ifcatotalcontractprice?'
            else if(this.tabName == 'ifca-total-contract-detail')
                this.urlRequestParams += '/v1/nfr/ifcacontractdetail?'
            else if(this.tabName == 'ifca-invoice-detail')
                this.urlRequestParams += '/v1/nfr/ifcainvoicedetail?'

            this.urlRequestParams += '&plant='+this.plant
			this.urlRequestParams += '&station='+this.stationid
			this.urlRequestParams += '&type='+this.stationtype
			this.urlRequestParams += '&area='+this.area
			this.urlRequestParams += '&region='+this.region
			this.urlRequestParams += '&owner='+this.owner
			this.urlRequestParams += '&lokasi='+this.lokasi
			this.urlRequestParams += '&status='+this.status
			this.urlRequestParams += '&group='+this.group

			this.urlRequestParams += '&year='+this.year
			this.urlRequestParams += '&month='+this.month

            this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					this.loading.isSuccess = true;
					this.reportdata = response.data;

                    if(this.reportdata) {
                        //default group = detail
                        let legend = 'Status';
                        let valuecol = 'Luas';
                        let label = 'StationName';
                        if(this.group == '') {
                            //
                        } else if(this.group == 'spbu') {
                            //
                        }

                        this.chartdata = this.processBarChart(this.reportdata.data, legend, "", valuecol, false, label, "", 1, 2, AppColors, false, false, false, this.stacked)
                    }

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },

        applyFilter() {
            this.getData()
        },
    }
}
</script>
